<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-11-28 11:57:13
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div slot="header">
        <div class="headerCardBox">
          <div style="width:400px">
            类型选择：
            <el-select v-model="value" placeholder="请选择">
              <el-option label="类型1" value="0">类型1</el-option>
              <el-option label="类型2" value="1">类型2</el-option>
            </el-select>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary" @click="TypeChange">查询</el-button>
          <el-button type="primary">重置</el-button>
        </div>
      </div>
      <div>
        <div class="adddBtnBox">
          <el-button type="primary">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="600" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="type" label="类型"></el-table-column>

          <el-table-column prop="questionDescribe" label="内容"></el-table-column>
          <el-table-column prop="userId" label="用户名"></el-table-column>
          <el-table-column prop="datetime" label="时间"></el-table-column>

          <el-table-column prop="address" label="状态"></el-table-column>
          <el-table-column prop="address" label="操作" width="250">
            <template slot-scope="scope">
              <el-button size="mini" @click="sendMsg(scope.row)">回复</el-button>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="prev, pager, next" :total="1"></el-pagination>
    </el-card>
    <el-dialog title="信息回复" :visible.sync="dialogVisible" width="30%">
      反馈内容：{{chooseData.questionDescribe}}
      <el-input
        type="textarea"
        placeholder="请输入回复信息"
        v-model="textarea"
        maxlength="30"
        show-word-limit
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      textarea: "",
      input1: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      value: "0",
      allData: [],
      dialogVisible: false,
      chooseData: {}
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    sendMsg(data) {
      console.log(data);
      this.chooseData = data;
      this.dialogVisible = true;
    },
    TypeChange() {
      this.tableData = this.allData[this.value];
    },
    getTableData() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/agroData/getUserFreedback",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          userId: "null"
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data[0];
        this.allData = res.data;
      });
    }
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
</style>